import {BaseHashParamsModel} from "./base-hash-params-model";

export class EntityContainerHashParamsModel extends BaseHashParamsModel {
  results: String;
  fixtures: String;
}
